<template>
  <div class="sidebar">
    <div class="sidebar-widget">
      <h4>Search Here</h4>
      <div class="search-box">
        <div class="form-group">
          <input type="search" placeholder="Search" />
          <button type="submit">
            <i class="ri-search-2-line"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="sidebar-widget popular-post">
      <h4>Popular Posts</h4>

      <div class="popular-post-widget">
        <div class="pp-post-item">
          <router-link to="/blog-details" class="pp-post-img">
            <img src="../../assets/images/blog/post-thumb-1.jpg" alt="Image" />
          </router-link>
          <div class="pp-post-info">
            <h6>
              <router-link to="/blog-details">
                The Success Of Treatment Of Stroke Patients Raises
              </router-link>
            </h6>
            <span>
              <i class="ri-calendar-event-fill"></i>
              12 Mar, 2022
            </span>
          </div>
        </div>
        <div class="pp-post-item">
          <router-link to="/blog-details" class="pp-post-img">
            <img src="../../assets/images/blog/post-thumb-2.jpg" alt="Image" />
          </router-link>
          <div class="pp-post-info">
            <h6>
              <router-link to="/blog-details">
                The Importance Of Exercise During Epidemic
              </router-link>
            </h6>
            <span>
              <i class="ri-calendar-event-fill"></i>
              25 Feb, 2022
            </span>
          </div>
        </div>
        <div class="pp-post-item">
          <router-link to="/blog-details" class="pp-post-img">
            <img src="../../assets/images/blog/post-thumb-3.jpg" alt="Image" />
          </router-link>
          <div class="pp-post-info">
            <h6>
              <router-link to="/blog-details">
                From Mediable Origin To Modern Treatment Era
              </router-link>
            </h6>
            <span>
              <i class="ri-calendar-event-fill"></i>
              23 Jan, 2022
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="sidebar-widget categories">
      <h4>News Category</h4>
      <div class="category-box">
        <ul class="list-style">
          <li>
            <a href="#">
              Cardiology
              <i class="ri-arrow-right-line"></i>
            </a>
          </li>
          <li>
            <a href="#">
              Gastrology
              <i class="ri-arrow-right-line"></i>
            </a>
          </li>
          <li>
            <a href="#">
              Opthalomology
              <i class="ri-arrow-right-line"></i>
            </a>
          </li>
          <li>
            <a href="#">
              Plastic Surgery
              <i class="ri-arrow-right-line"></i>
            </a>
          </li>
          <li>
            <a href="#">
              Orthopedic
              <i class="ri-arrow-right-line"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="sidebar-widget tags">
      <h4>Popular Tags</h4>
      <div class="tag-list">
        <ul class="list-style">
          <li><a href="#">Nurse</a></li>
          <li><a href="#">Doctors </a></li>
          <li><a href="#">Surgery</a></li>
          <li><a href="#">Dentist</a></li>
          <li><a href="#">Medicine</a></li>
          <li><a href="#">Antibiotic</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SideBar",
};
</script>